import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/contact/components/ContactInquiryPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/home-building-guide/[slug]/components/BudgetGuidePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/home-building-guide/[slug]/components/CareGuidePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/home-building-guide/[slug]/components/PlanningGuidePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Products/FaqEnquiryGrid.tsx");
